//libraries
import Vue from 'vue'
import axios from 'axios'

let resource = 'partner'
let resource_name = 'partner'

let state = {
  packages: [],
  admins: [],
  certifications: []
}

state[resource] = {}

//functions receive state
let getters = {

}

//functions receive context and params
let actions = {
  async get ({ commit }, params) {
    try {
      commit('setPartner', {})
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        commit('setPartner', res.data.resource)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name}.`})
      console.error(e)
    }
  },
  async create ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error creando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error creando ${resource_name}.`})
      console.error(e)
    }
  },
  async update ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`${resource}/${params[resource + '_id']}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando ${resource_name}.`})
      console.error(e)
    }
  },
  async destroy ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`${resource}/${params[resource + '_id']}`, {data: params})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando ${resource_name}.`})
      console.error(e)
    }
  },
  async packages ({ commit }, params) {
    try {
      commit('setPackages', [])
      let res = await Vue.request.get(`package`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        commit('setPackages', res.data.resource)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo packages de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo packages de ${resource_name}.`})
      console.error(e)
    }
  },
  async organizations ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}/organizations`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo información de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo información de ${resource_name}.`})
      console.error(e)
    }
  },
  async create_account ({ commit }, params) {
    try {
      let res = await Vue.request.post(`package/${params.package_id}/newAccount`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error creando cuenta.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error creando cuenta.`})
      console.error(e)
    }
  },
  async admins ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}/admins`, {params: params.params || {}})
      if(res.data.success) {
        commit('setAdmins', res.data.resource)
        if (params.callback) params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo admins de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo información de ${resource_name}.`})
      console.error(e)
    }
  },
  async send_email ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/${params[resource+'_id']}/send_email`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error enviando correo.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error enviando correo.`})
      console.error(e)
    }
  },
  async current_earning ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}/earning/now`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ganancias actual de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ganancias actual de ${resource_name}.`})
      console.error(e)
    }
  },
  async earnings ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}_earnings`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ganancias de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ganancias de ${resource_name}.`})
      console.error(e)
    }
  },
  async get_earning ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}_earnings/${params.partner_earning_id}`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ganancia de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ganancia de ${resource_name}.`})
      console.error(e)
    }
  },
  async asociated_packages ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}/packages`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo packages asociados a ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo packages asociados a ${resource_name}.`})
      console.error(e)
    }
  },
  async certifications ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}/certifications`, {params: params.params || {}})
      if(res.data.success) {
        commit('setCertifications', res.data.resource)
        if (params.callback) params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo certificaciones de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo certificaciones de ${resource_name}.`})
      console.error(e)
    }
  },
}

//functions receive state
let mutations = {
  setPartner (state, items) {
    state[resource] = items
  },
  updatePartnerAttribute (state, data) {
    try {
      state[resource][data.attribute] = data.value
    } catch (e) {}
  },
  setPackages (state, items) {
    state.packages = items
  },
  setAdmins (state, admins) {
    state.admins = Array.isArray(admins) ? admins : []
  },
  setCertifications (state, certifications) {
    state.certifications = Array.isArray(certifications) ? certifications : []
  },
  pushAdmin (state, admin) {
    state.admins.push(admin)
  },
  removeAdmin (state, admin) {
    let index = state.admins.findIndex(a => a.admin_id == admin.admin_id)
    if (index >= 0) {
      state.admins.splice(index, 1)
    }
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
